<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <span class="configurationBannerLabel">Coil Module</span>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (coilConstructionSelection) {
          <span class="halfWidthConfigurationInput">
            <span class="halfWidthInputLabel">Coil Construction:</span>
            <select
              class="halfWidthInputField"
              #controlVoltageInput
              [class.invalidConfigurationSelection]="isInvalidSelection(coilConstructionSelection.Name)"
              (change)="selectionChanged(coilConstructionSelection, controlVoltageInput.value)"
              [value]="coilConstructionSelection.Value.toString()">
              @for (allowable of coilConstructionSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="coilConstructionSelection.Value && coilConstructionSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
        @if (autoAirVentsSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(autoAirVentsSelection.Name)" for="autoAirVentsInput" class="halfWidthInputLabel">
              Auto Air Vents:
            </label>
            <input
              type="checkbox"
              class="checkboxInput"
              id="autoAirVentsInput"
              #autoAirVentsInput
              [checked]="'true' === autoAirVentsSelection.Value"
              (change)="selectionChanged(autoAirVentsSelection, autoAirVentsInput.checked.toString())" />
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (drainPanSelection) {
          <span class="halfWidthConfigurationInput">
            <span class="halfWidthInputLabel">Drain Pan:</span>
            <select
              class="halfWidthInputField"
              #drainPanInput
              [class.invalidConfigurationSelection]="isInvalidSelection(drainPanSelection.Name)"
              (change)="selectionChanged(drainPanSelection, drainPanInput.value)"
              [value]="drainPanSelection.Value.toString()">
              @for (allowable of drainPanSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="drainPanSelection.Value && drainPanSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
        @if (drainValveSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(drainValveSelection.Name)" for="drainValveInput" class="halfWidthInputLabel">Drain Valve:</label>
            <input
              type="checkbox"
              class="checkboxInput"
              id="drainValveInput"
              #drainValveInput
              [checked]="'true' === drainValveSelection.Value"
              (change)="selectionChanged(drainValveSelection, drainValveInput.checked.toString())" />
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        <span class="halfWidthConfigurationInput"></span>
        @if (oppositeEndConnectionsSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(oppositeEndConnectionsSelection.Name)" for="oppositeEndConnectionsInput" class="halfWidthInputLabel">
              Opposite End Coil Connections:
            </label>
            <input
              type="checkbox"
              class="checkboxInput"
              id="oppositeEndConnectionsInput"
              #oppositeEndConnectionsInput
              [checked]="'true' === oppositeEndConnectionsSelection.Value"
              (change)="selectionChanged(oppositeEndConnectionsSelection, oppositeEndConnectionsInput.checked.toString())" />
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        <span class="halfWidthConfigurationInput"></span>
        @if (preHeatSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(preHeatSelection.Name)" for="preHeatInput" class="halfWidthInputLabel">PreHeat:</label>
            <input
              type="checkbox"
              class="checkboxInput"
              id="preHeatInput"
              #preHeatInput
              [checked]="'true' === preHeatSelection.Value"
              (change)="selectionChanged(preHeatSelection, preHeatInput.checked.toString())" />
          </span>
        }
      </div>
    </div>
  }
</div>
